import { useCallback } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export function useViewDataset() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const datasetId = searchParams.get('datasetId') || undefined;
  const datasetModalId = searchParams.get('datasetModalId') || undefined;

  const setSearchParam = useCallback(
    async (key: string, value: string | undefined) => {
      const newSearchParams = new URLSearchParams(searchParams);
      if (value) {
        newSearchParams.set(key, value);
      } else {
        newSearchParams.delete(key);
      }
      await navigate({ search: newSearchParams.toString() }, { replace: true });
    },
    [navigate, searchParams],
  );

  const setDatasetId = async (id: string | undefined) => {
    if (!!id && !!datasetModalId) {
      await setSearchParam('datasetModalId', id);
    } else {
      await setSearchParam('datasetId', id);
    }
  };

  const setDatasetModalId = async (id: string | undefined) => {
    await setSearchParam('datasetModalId', id);
  };

  const isModalOpen = !!datasetModalId;

  return { datasetId, setDatasetId, datasetModalId, setDatasetModalId, isModalOpen };
}
